import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { pairwise } from 'rxjs/operators';
import { ParamPhoneMaskHn, ParamPhoneMaskNoHn } from 'src/app/@core/constants';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { City } from 'src/app/models/city';
import { Colony } from 'src/app/models/colony';
import { Nationality } from 'src/app/models/nationality';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { Region } from 'src/app/models/region';
import { CityService } from 'src/app/services/city.service';
import { ColonyService } from 'src/app/services/colony.service';
import { NationalityService } from 'src/app/services/nationality.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import { ParamsService } from 'src/app/services/params.service';
import { RegionService } from 'src/app/services/region.service';

@Component({
  selector: 'app-person-address-information-step',
  templateUrl: './person-address-information-step.component.html',
  styleUrls: ['./person-address-information-step.component.sass']
})
export class PersonAddressInformationStepComponent implements OnInit, OnChanges {

  constructor(private nationalityService: NationalityService, private cityService: CityService, private regionService: RegionService, private colonyService: ColonyService, private paramService: ParamsService, private onbaseService: OnbaseService) { }

  @Input() personAddressInformationForm = new FormGroup({
    homeType: new FormControl("", Validators.required),
    liveFromDate: new FormControl("", Validators.required),
    country: new FormControl("HN", Validators.required),
    deparment: new FormControl("", Validators.required),
    city: new FormControl("", Validators.required),
    neighborhood: new FormControl("", Validators.required),
    street: new FormControl("", Validators.required),
    street2: new FormControl(""),
    street3: new FormControl(""),
    street4: new FormControl(""),
    street5: new FormControl(""),
    mobilePhone: new FormControl("", Validators.required),
    phone: new FormControl("")
  });
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  @Input() isEdit = false;
  @Input() hideStreeFields = false;
  filterHomeTypes = ["Z003", "Z002", "Z004", "Z001"]
  homeTypes: Array<{ key: string, value: string }> = [];
  nationalities: Array<Nationality> = [];
  cities: Array<City> = [];
  departments: Array<Region> = [];
  neighborhoods: Array<Colony> = [];
  phoneMaskHN: string = "";
  phoneMaskNonHN: string = "";
  currentMask: string = "";
  @Input() readonly = false;
  @Input() isShortFormActiveForPlan = false;
  async ngOnInit(): Promise<void> {
    if (this.onbaseCatalogue.economicActivity.length == 0) {
      this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    }
    this.nationalities = (await this.nationalityService.readNationalities().toPromise()).response.content;
    this.phoneMaskHN = (await this.paramService.readParam(ParamPhoneMaskHn).toPromise()).response.value;
    this.phoneMaskNonHN = (await this.paramService.readParam(ParamPhoneMaskNoHn).toPromise()).response.value;
    this.homeTypes = ObjectUtils.objectToArray(this.onbaseCatalogue.homeType).filter(f => this.filterHomeTypes.includes(f.key));

    await this.changeCountry({ code: this.personAddressInformationForm.get("country")?.value, name: "", country: "" }, false);

    this.personAddressInformationForm.valueChanges.pipe(pairwise()).subscribe(async ([prev, next]) => {
      // if (next.country && prev.country != next.country && this.isEdit) {
      //   await this.changeCountry({ code: next.country, name: "", country: "" });
      // }
      if (next.deparment && next.deparment != prev.deparment && this.isEdit) {
        await this.changeDepartment({ country: next.country, id: '', name: '', region: next.deparment }, false)
      }
      if (next.city && next.city != prev.city && this.isEdit) {
        await this.changeDepartment({ country: next.country, id: '', name: '', region: next.deparment }, false)
        await this.changeCity({ cityCode: next.city, code: '', countryCode: '', name: '', regionCode: '' }, false);
      }

    })
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (this.isEdit) {
      await this.changeCountry({ code: this.personAddressInformationForm.get("country")?.value, name: "", country: "" }, false);
      await this.changeDepartment({ country: this.personAddressInformationForm.value.country, id: '', name: '', region: this.personAddressInformationForm.value.deparment }, false)
      await this.changeCity({ cityCode: this.personAddressInformationForm.value.city, code: '', countryCode: '', name: '', regionCode: '' }, false);
    }
  }

  async changeCountry(item: Nationality, reset: boolean = true): Promise<void> {
    this.departments = (await this.regionService.readRegions(item.code).toPromise()).response.content;

    this.resetFields(item, reset);
  }

  private resetFields(item: Nationality, reset: boolean) {
    if (item.code == "HN") {
      this.currentMask = this.phoneMaskHN;
    }
    else {
      this.currentMask = this.phoneMaskNonHN;
    }
    if (reset) {
      this.personAddressInformationForm.get("deparment")?.reset();
      this.personAddressInformationForm.get("city")?.reset();
      this.personAddressInformationForm.get("neighborhood")?.reset();
      this.personAddressInformationForm.get("street")?.reset();
      this.personAddressInformationForm.get("companyPhone")?.reset();
    }
    this.personAddressInformationForm.get("deparment")?.markAsDirty();
    this.personAddressInformationForm.get("city")?.markAsDirty();
    this.personAddressInformationForm.get("neighborhood")?.markAsDirty();
    this.personAddressInformationForm.get("street")?.markAsDirty();
    this.personAddressInformationForm.get("companyPhone")?.markAsDirty();
    this.cities = [];
    this.neighborhoods = [];

  }

  async changeDepartment(item: Region, reset: boolean = true): Promise<void> {
    this.cities = (await this.cityService.readCities(item.country, item.region).toPromise()).response.content;
    if (reset) {
      this.personAddressInformationForm.get("neighborhood")?.reset();
      this.personAddressInformationForm.get("city")?.reset();
    }
  }

  async changeCity(item: City, reset: boolean = true): Promise<void> {
    this.neighborhoods = (await this.colonyService.readColonies(item.cityCode).toPromise()).response.content;
    if (reset) {
      this.personAddressInformationForm.get("neighborhood")?.reset();
    }
  }
}
